module.exports = __webpack_public_path__ + "img/demo2.dd24c86d.png";